import Vue from 'vue';

export default {
    async getAll() {
        return (await Vue.http.get('/api/timezones')).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/timezone.service.js